import { MdArrowForward } from "react-icons/md";

import Logo from "../Assets/images/miltis-logo.svg";
import YousignLogo from "../Assets/images/yousign-icon.svg";
import InfoBox from "../Components/InfoBox";
import Layout from "../Components/Layout";

function View({ onBack, translate }) {
  return (
    <Layout centered>
      <div className="miltis-subscription-done">
        <div className="miltis-subscription-done__content">
          <div className="miltis-subscription-done__header">
            <img
              src={Logo}
              alt="Miltis"
              className="miltis-subscription-done__icon"
            />
            <h1 className="miltis-subscription-done__title">
              {translate?.TITLE || "Bienvenue chez Miltis !"}
            </h1>
            <p className="miltis-subscription-done__text">
              {translate?.TEXT ||
                "Vous recevrez prochainement un email de bienvenue comportant toutes les informations relatives à votre contrat."}
            </p>
          </div>

          <div className="miltis-subscription-done__info">
            <InfoBox
              icon={<img src={YousignLogo} alt="Yousign" />}
              variant="success"
              text={
                translate?.INFOBOX?.TEXT ||
                "Un email vous a été envoyé de la part de Yousign avec l'ensemble des documents signés."
              }
            />
          </div>

          <button
            className="miltis-subscription-done__button"
            onClick={() => {
              window.location.href = "https://www.mutuelle-miltis.fr/";
            }}
          >
            <span>
              {translate?.BUTTON?.BACK_TO_HOME || "Revenir à la page d'accueil"}
            </span>
            <MdArrowForward size={24} />
          </button>
        </div>
      </div>
    </Layout>
  );
}

export default View;
